import CardClass from "../../../CardClass";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid2";

export default class CardAdminProviderExternalIdentifiers extends CardClass {
  /**
   * Render the content of the card.
   */
  renderContent() {
    return (
      <MUIGrid container spacing={2}>
        <MUIGrid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <MUITextField
            value={
              this.props.provider && this.props.provider.brightreeExternalKey
                ? this.props.provider.brightreeExternalKey
                : ""
            }
            size="small"
            label="Brightree ID"
            variant="standard"
            fullWidth={true}
            onBlur={(e) => {
              if (e.target.value.trim() === "") {
                // If the input is an empty string, set it to null
                this.props.onChange({ brightreeExternalKey: null });
              } else if (!isNaN(e.target.value.trim())) {
                // If it's a valid number, parse it as an integer
                this.props.onChange({
                  brightreeExternalKey: parseInt(e.target.value.trim()),
                });
              } else {
                // If it's invalid input (non-numeric), keep the value as-is (text)
                this.props.onChange({
                  brightreeExternalKey: e.target.value.trim(),
                });
              }
            }}
            onChange={(e) =>
              this.props.onChange({ brightreeExternalKey: e.target.value })
            }
            error={
              this.props.validationIssues.brightreeExternalKey ? true : false
            }
            helperText={
              this.props.validationIssues.brightreeExternalKey
                ? this.props.validationIssues.brightreeExternalKey
                : ""
            }
            slotProps={{
              inputLabel: { shrink: true },
            }}
          />
        </MUIGrid>
        <MUIGrid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <MUITextField
            value={
              this.props.provider && this.props.provider.taxId
                ? this.props.provider.taxId
                : ""
            }
            size="small"
            label="Tax ID"
            variant="standard"
            fullWidth={true}
            onChange={(e) => this.props.onChange({ taxId: e.target.value })}
            error={this.props.validationIssues.taxId ? true : false}
            helperText={
              this.props.validationIssues.taxId
                ? this.props.validationIssues.taxId
                : ""
            }
            slotProps={{
              inputLabel: { shrink: true },
            }}
          />
        </MUIGrid>
      </MUIGrid>
    );
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "External Identifiers";
  }
}
